import { __read } from "tslib";
import ActionContextMenuControl from '@office-start/action-context-menu-control';
import ContextMenuControl from '@office-start/context-menu-control';
import React, { useCallback, useEffect, useRef, useState } from 'react';
export var RightClickActionsMenu = function (_a) {
    var actions = _a.actions, componentRef = _a.componentRef, contentActionsEnabled = _a.contentActionsEnabled, groupInfo = _a.groupInfo, item = _a.item, onActionMenuToggled = _a.onActionMenuToggled;
    var _b = __read(useState(false), 2), menuOpened = _b[0], setMenuOpened = _b[1];
    var mouseEventRef = useRef(null);
    var contextMenuListenerCallback = useCallback(function (e) {
        // Did user right-click this item (triggered contextmenu event below)?
        if (componentRef.current &&
            e.target instanceof Node &&
            componentRef.current.contains(e.target)) {
            e.preventDefault();
            mouseEventRef.current = e;
            if (!contentActionsEnabled && onActionMenuToggled) {
                onActionMenuToggled(!menuOpened);
            }
            setMenuOpened(function (currentState) {
                return !currentState;
            });
        }
        else {
            // User clicked somewhere else. If the menu is open, close it!
            if (menuOpened) {
                if (!contentActionsEnabled && onActionMenuToggled) {
                    onActionMenuToggled(false);
                }
                setMenuOpened(false);
            }
        }
    }, [
        componentRef,
        contentActionsEnabled,
        menuOpened,
        onActionMenuToggled,
        setMenuOpened,
    ]);
    var clickListenerCallback = useCallback(function () {
        if (menuOpened) {
            if (!contentActionsEnabled && onActionMenuToggled) {
                onActionMenuToggled(false);
            }
            setMenuOpened(false);
        }
    }, [menuOpened, contentActionsEnabled, onActionMenuToggled, setMenuOpened]);
    useEffect(function () {
        document.addEventListener('contextmenu', contextMenuListenerCallback);
        document.addEventListener('click', clickListenerCallback);
        return function () {
            document.removeEventListener('click', clickListenerCallback);
            document.removeEventListener('contextmenu', contextMenuListenerCallback);
        };
    }, [componentRef, clickListenerCallback, contextMenuListenerCallback]);
    if (!menuOpened) {
        return null;
    }
    // $TODO: evlave The v9 approach to doing this is to wrap your component in the menu
    // and set the `openOnContext` prop to true.
    if (contentActionsEnabled) {
        return (React.createElement(ActionContextMenuControl, { groupInfo: groupInfo, items: actions, defaultOpen: true, onActionMenuToggled: onActionMenuToggled, target: mouseEventRef.current }));
    }
    return (React.createElement(ContextMenuControl, { menu: {
            items: actions,
            id: "right-click-actions-menu-".concat(item.id),
        }, hidden: false, mouseEvent: mouseEventRef.current || undefined }));
};
//# sourceMappingURL=RightClickActionsMenu.js.map